var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFriendlyGuyAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 640,
    height: 640,
    viewBox: "0 0 640 640",
    className: "injected-svg",
    role: "img",
    artist: "Katerina Limpitsouni",
    copyright: "unDraw",
    scrapped: "true",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a-40"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 320,
    transform: "translate(1131 211)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-605 -80)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 320,
    r: 320,
    transform: "translate(605 80)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-526 -131)",
    clipPath: "url(#a-40)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M308.917,275.306a56.766,56.766,0,1,0-76.214,50.68l7.587,72.956,58.052-43.966s-11.356-15.94-17.023-33.58A56.7,56.7,0,0,0,308.917,275.306Z",
    transform: "translate(1202.512 213.572)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4,521.694l-16.694-55.37s-31.3,121.137-1.081,121.137,82.654-37.327,82.654-37.327L65.141,501.289Z",
    transform: "translate(1245.398 155.822)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.466,572.6l-.193,83.81-12.25,62.834-74.1-.177,30.356-141.756Z",
    transform: "translate(1161.584 131.316)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.109,374.625,178,391.067s-55.991,5.332-61.324,24.885S97.125,435.5,98.014,447.059L70.463,481.72s37.772,40.438,37.772,52.881,24.441-6.879,24.441-6.879V673.867H327.914l5.175-122.38s48.881-34.661,62.213-9.776l-14.22-59.546s.889-43.549-27.551-64.879l-67.545-32s-5.584-9.6-26.914-11.377l-14.857,36.262-32.884,21.33Z",
    transform: "translate(1231.332 177.133)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.54,351.749,65.678,488.9l-47.541,3.285L34.8,349.941c-6.576-7.017-10.511-17.481-9.959-29,.965-20.149,15.265-35.835,31.94-35.036s29.41,17.78,28.444,37.929C84.674,335.353,79.756,345.393,72.54,351.749Z",
    transform: "translate(1243.398 197.434)",
    fill: "#ed9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.626,274.851l-10.355-4.145s18.826-15.054,48.948-12.981c0,0,46.455-2.167,53.593,12.981l19.868,22.418-4.628,10.191,16.2,10.19-16.626-1.83a56.391,56.391,0,0,1-1.573,26.392l.446,8.055s-19.272-29.818-19.272-33.963v10.363s-10.354-9.327-10.354-15.545l-5.648,7.254-2.824-11.4-34.828,11.4,5.648-9.327-21.65,3.109,8.472-11.4s-24.474,13.472-25.415,24.872-13.178,25.908-13.178,25.908L441.8,337.031S433.328,290.4,460.626,274.851Z",
    transform: "translate(950.26 150.506)",
    fill: "#090814"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendlyGuyAvatar);
export default __webpack_public_path__ + "static/media/friendly-guy-avatar.c4b5b2d22a594ef4257fb9f40ec42834.svg";
export { ForwardRef as ReactComponent };